import { Button, Stack } from "@mui/material";
import Form from "@poseidon/ui/components/form/FullWidthForm";
import { Panel } from "@poseidon/ui/components/Panel";
import {
  FormikDisabler,
  usePermissions,
} from "@poseidon/ui/components";
import { ToggleButtonControl } from "@poseidon/ui/components/ToggleButtonControl";
import config from "@poseidon/utils/config";
import { Formik } from "formik";

export const KycAmlPepResults = ({
  sailorRiskProfile,
  updateSailorRiskProfile,
}) => {
  const { canWrite } = usePermissions();
  const { smartSearchAmlResults, pepOptions } = config;
  return (
    <Formik
      initialValues={{
        kycAmlResult: sailorRiskProfile.kycAmlResult ?? "pending",
        pepStatus: sailorRiskProfile.pepStatus ?? "pending",
      }}
      enableReinitialize
      onSubmit={updateSailorRiskProfile}
    >
      {({ dirty, isSubmitting }) => (
        <Form>
          <FormikDisabler disabled={!canWrite} />
          <Panel
            title="Result"
            expandable
            actions={
              <Button
                size="small"
                type="submit"
                disabled={!dirty || isSubmitting || !canWrite}
              >
                Save
              </Button>
            }
          >
            <Stack spacing={2}>
              <ToggleButtonControl
                name="kycAmlResult"
                label="KYC/AML Result"
                options={smartSearchAmlResults}
                helperText={
                  "This will be automatically set after running checks"
                }
              />
              <ToggleButtonControl
                name="pepStatus"
                label="PEP Status"
                options={pepOptions}
                helperText={
                  "This will be automatically set after running checks"
                }
              />
            </Stack>
          </Panel>
        </Form>
      )}
    </Formik>
  );
};
